import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../utils/constants";
import LoadingSpinner from "../components/LoadingSpinner";
import ReusableTable from "../components/ReusableTable";
import { Form } from "react-bootstrap";
import ClearForm from "../components/Clearform";
import CustomStepper from "../components/CustomStepper";
import * as XLSX from "xlsx";

const getBorrowerName = (borrowers = []) =>
  borrowers.find((b) => b?.Type === "B" || b?.type === "B")?.Cust_name ||
  borrowers.find((b) => b?.Type === "B" || b?.type === "B")?.custName ||
  borrowers[0]?.Cust_name ||
  borrowers[0]?.custName ||
  "N/A";

const formatDisplayDate = (dateValue) => {
  if (!dateValue) {
    return null;
  }

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const getFirmLabel = (firm) =>
  (
    firm?.firmName ||
    firm?.Firm_name ||
    firm?.firm_name ||
    firm?.FirmName ||
    firm?.name ||
    ""
  )
    .toString()
    .trim();

const getArbitratorName = (arbitrator) =>
  (
    arbitrator?.Arb_name ||
    arbitrator?.arbName ||
    arbitrator?.arb_name ||
    arbitrator?.name ||
    arbitrator?.Name ||
    ""
  )
    .toString()
    .trim();

const getArbitratorId = (arbitrator) => {
  const rawId =
    arbitrator?.Arb_id ??
    arbitrator?.arbId ??
    arbitrator?.arb_id ??
    arbitrator?.id ??
    arbitrator?.Id ??
    arbitrator?.Ref_id ??
    arbitrator?.refId;

  const numericId = Number(rawId);
  return Number.isFinite(numericId) ? numericId : null;
};

const AssignArbitrator = () => {
  const [arbitrators, setArbitrators] = useState([]);
  const [data, setData] = useState([]);
  const [unassignedLots, setUnassignedLots] = useState([]);
  const [unassignedData, setUnassignedData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showData, setShowData] = useState(false);
  const [firms, setFirms] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState("");
  const [selectedLotNo, setSelectedLotNo] = useState([]);
  const [selectedClientID, setSelectedClientID] = useState([]);
  const [selectedProductID, setSelectedProductID] = useState([]);
  const [selectedArbitrators, setSelectedArbitrators] = useState([]);
  const [upload, setUpload] = useState(false);
  const [clearForm, setClearForm] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [firmTouched, setFirmTouched] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  // for unassigned Data
  const [currentPage1, setCurrentPage1] = useState(1);
  // const itemsPerPage = 10;
  // const [pageNumbers1, setPageNumbers1] = useState([]);
  // for assigned Data
  const [currentPage2, setCurrentPage2] = useState(1);
  const itemsPerPage = 10;
  // const [pageNumbers2, setPageNumbers2] = useState([]);

  // To fetch Firms
  useEffect(() => {
    const fetchFirms = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Firms`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        const parsedFirms = Array.isArray(result) ? result : JSON.parse(result); // Ensure parsedArbitrators is an array
        const normalizedFirms = Array.from(
          new Set(parsedFirms.map(getFirmLabel).filter(Boolean))
        ).map((firmName) => ({ Firm_name: firmName }));
        setFirms(normalizedFirms);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchFirms();
  }, []);

  // console.log(firms);

  const handleFirmChange = (e) => {
    const value = e.target.value;
    setSelectedFirm(value);
    setFirmTouched(true);
    if (value) {
      setValidationErrors((prev) => ({ ...prev, firm: null }));
    }
  };

  // To fetch the arbitrators based on firm
  useEffect(() => {
    const fetchArbitrators = async () => {
      if (!selectedFirm) {
        setSelectedArbitrators([]);
        return;
      }

      setError(null);
      const selectedFirmEncoded = encodeURIComponent(selectedFirm);
      console.log(selectedFirmEncoded);
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/arb?firm=${selectedFirmEncoded}`
          // `${API_BASE_URL}/api/products?client_id=${selectedFirm}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        const parsedArbitrators = Array.isArray(result) ? result : JSON.parse(result);
        const normalizedArbitrators = parsedArbitrators
          .map((arbitrator) => ({
            ...arbitrator,
            Arb_id: getArbitratorId(arbitrator),
            Arb_name: getArbitratorName(arbitrator),
          }))
          .filter((arbitrator) => arbitrator.Arb_id && arbitrator.Arb_name);

        setSelectedArbitrators(normalizedArbitrators);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchArbitrators();
  }, [selectedFirm]);

  // unassignedLots Fetch Code
  useEffect(() => {
    const fetchUnassignedLots = async () => {
      // setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/unassignLots`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        const parsedUnassignedLots = Array.isArray(result)
          ? result
          : JSON.parse(result);
        console.log('Raw API data:', parsedUnassignedLots);
        // Normalize the data to ensure consistent field names
        const normalizedLots = parsedUnassignedLots.map(lot => {
          const normalized = {
            Lots: lot.Lots || lot.lotNo?.toString() || "",
            Lot_no: lot.lotNo || lot.Lot_no,
            Client_id: lot.clientId || lot.Client_id,
            Product_id: lot.productId || lot.Product_id,
            uploadedDate: lot.uploadedDate || lot.uploaded_date,
            Uploaded_date: lot.uploadedDate || lot.uploaded_date || lot.Uploaded_date,
            assignDate: lot.assignDate || lot.assign_date,
            days: lot.days
          };
          console.log('Normalized lot:', normalized);
          return normalized;
        });
        setUnassignedLots(normalizedLots);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUnassignedLots();
  }, []);

  console.log(unassignedLots);

  const filteredLots = unassignedLots.filter((item) =>
    item.Lots.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredLots.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredLots.length / rowsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading) return <LoadingSpinner />;

  const handleGetUnassignedLots = async (item) => {
    console.log(item);
    setSelectedLotNo(item.Lot_no);
    setSelectedClientID(item.Client_id);
    setSelectedProductID(item.Product_id);
    // setSelectedArbitratorID(item.Arbitrator_id);
    setLoading(true); // Start loading
    try {
      const url = `${API_BASE_URL}/api/unassignLots?lotNo=${item.Lot_no}&clientId=${item.Client_id}&productId=${item.Product_id}`;
      console.log(url);
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      // console.log(result);
      const parsedUnassignedData = Array.isArray(result)
        ? result
        : JSON.parse(result);
      // const parsedUnassignedData = JSON.parse(result); // Ensure parsedArbitrators is an array
      setUnassignedData(parsedUnassignedData);
      // toast.success("Data Received Successfully", {
      //   position: toast.POSITION.BOTTOM_RIGHT,
      //   theme: "colored",
      //   autoClose: 1000,
      // });
      setShowData(true);
      handleStepChange(1);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  // console.log(unassignedData);

  // Pagination for unassigned Data starts
  const indexOfLastItem1 = currentPage1 * itemsPerPage;
  const indexOfFirstItem1 = indexOfLastItem1 - itemsPerPage;
  console.log(unassignedData);
  const updatedData = unassignedData.map((item) => ({
    Reference_no: item.referenceNo || item.Reference_no || "Not provided",
    Cust_name: item.Cust_name || getBorrowerName(item.borrowers),
    LRN_Date: formatDisplayDate(item.LRN_Date || item.uploadedDate),
    Uploaded_date: formatDisplayDate(item.Uploaded_date || item.uploadedDate),
  }));
  const currentItems1 = updatedData.slice(indexOfFirstItem1, indexOfLastItem1);
  const totalPages1 = Math.ceil(updatedData.length / itemsPerPage);
  const pageNumbers1 = Array.from({ length: totalPages1 }, (_, i) => i + 1);
  // Pagination for unassigned Data ends

  if (loading) return <LoadingSpinner />;

  // the Arbitrator assignment function Starts here
  const handleAssign = () => {
    setFirmTouched(true);
    if (!selectedFirm) {
      return;
    }
    if (!unassignedData.length) {
      setValidationErrors((prev) => ({ ...prev, assign: "No cases available to assign." }));
      return;
    }
    if (!selectedArbitrators.length) {
      setValidationErrors((prev) => ({ ...prev, assign: "No valid arbitrators found for the selected firm." }));
      return;
    }
    setValidationErrors({});

    // Shuffle arbitrators array to ensure randomness
    const shuffledArbitrators = [...selectedArbitrators].sort(
      () => Math.random() - 0.5
    );

    const totalLots = unassignedData.length;
    const totalArbitrators = shuffledArbitrators.length;
    const lotsPerArbitrator = Math.floor(totalLots / totalArbitrators);
    const remainingLots = totalLots % totalArbitrators;

    // Create an array of arbitrators repeated 'lotsPerArbitrator' times
    let arbitratorPool = shuffledArbitrators.flatMap((arbitrator) =>
      Array(lotsPerArbitrator).fill(arbitrator)
    );

    // Distribute remaining lots to the arbitrators
    for (let i = 0; i < remainingLots; i++) {
      arbitratorPool.push(shuffledArbitrators[i]);
    }

    // Shuffle the arbitratorPool to randomize assignments
    arbitratorPool = arbitratorPool.sort(() => Math.random() - 0.5);

    // Object to track assignment counts
    const assignmentCounts = shuffledArbitrators.reduce((acc, arbitrator) => {
      acc[arbitrator.Arb_name] = 0;
      return acc;
    }, {});

    // Assign arbitrators randomly but equally distributed to the data
    const dataWithAssignments = unassignedData.map((item, index) => {
      const arbitrator = arbitratorPool[index]; // Randomized but equally distributed arbitrator
      // console.log(arbitrator);

      assignmentCounts[arbitrator.Arb_name] += 1;

      return {
        assignedArbitrator: arbitrator.Arb_name,
        assignedArbitratorId: arbitrator.Arb_id,
        ...item,
      };
    });

    console.log("Data with Assignments:", dataWithAssignments);
    // console.log("Assignment Counts:", assignmentCounts);

    const updatedData = dataWithAssignments.map((item) => ({
      assignedArbitrator: item.assignedArbitrator,
      Reference_no: item.referenceNo || item.Reference_no || "Not provided",
      Cust_name: item.Cust_name || getBorrowerName(item.borrowers),
      LRN_Date: formatDisplayDate(item.LRN_Date || item.uploadedDate),
      Uploaded_date: formatDisplayDate(item.Uploaded_date || item.uploadedDate),
      Case_id: item.caseId || item.Case_id,
      assignedArbitratorId: item.assignedArbitratorId,
    }));
    setUpload(true);
    setData(updatedData);
    handleStepChange(2);

    // setFilteredDataForSelect(updatedData);
    // setAssignedData(dataWithAssignments);

    // toast.success("Arbitrator Assigned Successfully!", {
    //   position: toast.POSITION.BOTTOM_RIGHT,
    //   theme: "colored",
    //   autoClose: 1000,
    // });
    // setShowAssigned(true);
    // setShowTable(true);
    // setIsDisabled(true);
  };
  console.log(data);
  // console.log(upload);
  // the Arbitrator assignment function ends here

  // Pagination Logic for Assigned Data starts
  const totalPages2 = Math.ceil(data.length / itemsPerPage);
  const pageNumbers2 = Array.from({ length: totalPages2 }, (_, i) => i + 1);

  const indexOfLastItem2 = currentPage2 * itemsPerPage;
  const indexOfFirstItem2 = indexOfLastItem2 - itemsPerPage;
  // const updatedData = unassignedData.map((item, index) => {
  //   const { Case_id, UPLODED_DATE, ...rest } = item;
  //   return {
  //     ...rest,
  //   };
  // });
  const currentItems2 = data.slice(indexOfFirstItem2, indexOfLastItem2);
  // Pagination Logic for Assigned Data ends

  if (loading) return <LoadingSpinner />;

  const formattedData = data.map((item) => ({
    Case_id: Number(item.Case_id),
    Arb_id: Number(item.assignedArbitratorId),
  })).filter(
    (item) => Number.isFinite(item.Case_id) && Number.isFinite(item.Arb_id)
  );
  console.log(formattedData);

  // the data upload function starts here
  const handleUpload = async () => {
    if (!data.length) {
      setValidationErrors((prev) => ({ ...prev, upload: "No assignment data to upload. Please assign arbitrators first." }));
      return;
    }

    const formattedData = data
      .map((item) => ({
        caseId: Number(item.Case_id),
        arbId: Number(item.assignedArbitratorId),
      }))
      .filter(
        (item) => Number.isFinite(item.caseId) && Number.isFinite(item.arbId)
      );

    console.log(formattedData);

    if (formattedData.length !== data.length) {
      setValidationErrors((prev) => ({ ...prev, upload: "Some rows have invalid Case ID or Arbitrator ID. Please reassign and try again." }));
      return;
    }

    setValidationErrors({});

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/assignArb`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formattedData),
      });

      if (!response.ok) {
        throw new Error(` Response is not OK Error: ${response.status}`);
      }

      const result = await response.json();
      console.log("Success:", result);
      handleStepChange(3);
      setClearForm(true);
    } catch (error) {
      console.error("Error uploading data:", error);
      alert(`Error uploading data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  // the data upload function ends here

  // For the customStepper starts Here
  const steps = ["Select Lot", "Assign Arbitrator", "Upload Data"];

  // Function to move to a specific step in Stepper Component
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  // For the customStepper ends Here

  const handleExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert JSON data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Arbitration Data");

    // Write the workbook to a file
    XLSX.writeFile(workbook, "ArbitrationData.xlsx");
    setIsDisabled(true);
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-12">
          <CustomStepper steps={steps} activeStep={activeStep} />
        </div>
      </div>

      {error && (
        <div className="alert alert-danger py-2" role="alert" style={{ fontSize: "13px" }}>
          {typeof error === "string" ? error : error?.message || "An error occurred."}
        </div>
      )}

      {!unassignedLots.length > 0 && (
        <p className="text-center">No unassigned Lots Are Available</p>
      )}

      {showData && (
        <div className="row">
          <div className="col-md-4">
            {!upload && (
              <div>
                <Form.Select
                  aria-label="Default select example"
                  onChange={handleFirmChange}
                  className={`custom_input ${firmTouched && !selectedFirm ? "is-invalid" : ""}`}
                  required
                  defaultValue=""
                  style={{ fontSize: "12px" }}
                >
                  <option value="" disabled>
                    Choose Firm
                  </option>
                  {firms.map((item) => (
                    <option key={item.Firm_name} value={item.Firm_name}>{item.Firm_name}</option>
                  ))}
                </Form.Select>
                {firmTouched && !selectedFirm && (
                  <div className="invalid-feedback" style={{ display: "block", fontSize: "12px" }}>
                    Please select a firm.
                  </div>
                )}
              </div>
            )}
            {upload && !clearForm && (
              <button
                className="custBtn"
                onClick={handleExport}
                disabled={isDisabled}
              >
                Export To Excel
              </button>
            )}
          </div>
          <div className="col-md-3"></div>
          <div className="col-md-3 d-flex justify-content-end"></div>
          <div className="col-md-2">
            {!upload && (
              <>
                <button
                  className="custBtn"
                  onClick={handleAssign}
                >
                  Assign
                </button>
                {validationErrors.assign && (
                  <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                    {validationErrors.assign}
                  </div>
                )}
                {!selectedFirm && !firmTouched && (
                  <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                    Select a firm first
                  </div>
                )}
              </>
            )}
            {upload && !clearForm && (
              <>
                <button className="custBtn" onClick={handleUpload}>
                  Upload
                </button>
                {validationErrors.upload && (
                  <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                    {validationErrors.upload}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {!showData && unassignedLots.length > 0 && (
        <div className="row table-container">
          <div className="col-md-12 mx-auto table-wrapper">
            {/* Search Input */}
            <div className="mb-1 d-flex justify-content-start">
              <input
                type="text"
                placeholder="Search Lots..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1); // reset to first page on search
                }}
                className="form-control"
                style={{ maxWidth: "300px", fontSize: "12px" }}
              />
            </div>

            {/* Table */}
            <table className="responsive-table ">
              <thead className="text-center">
                <tr className="table-info">
                  <th scope="col" className="text-center">
                    Sr No
                  </th>

                  <th scope="col" className="text-center">
                    Uploaded Date
                  </th>
                  <th scope="col" className="text-center">
                    Days
                  </th>
                  <th scope="col" className="text-center">
                    Lots
                  </th>
                  <th scope="col" className="text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentRows.length > 0 ? (
                  currentRows.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-center p-0">
                        {indexOfFirstRow + index + 1}
                      </td>
                      <td className="text-center p-0">
                        {item.Uploaded_date
                          ? new Date(item.Uploaded_date).toLocaleDateString(
                            "en-GB",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )
                          : ""}
                      </td>
                      <td className="text-center p-0">{item.days}</td>
                      <td className="text-center p-0">{item.Lots}</td>
                      <td className="text-center p-1">
                        <button
                          onClick={() => handleGetUnassignedLots(item)}
                          className="custBtn"
                        >
                          Show
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-center">
              <nav>
                <ul className="pagination">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}

      {showData && !upload && (
        <div className="row">
          <div className="col-md-12">
            <ReusableTable
              data={currentItems1}
              currentPage={currentPage1}
              pageNumbers={pageNumbers1}
              setCurrentPage={setCurrentPage1}
            />
          </div>
        </div>
      )}

      {upload && !clearForm && (
        <div className="row">
          <div className="col-md-12">
            <ReusableTable
              data={currentItems2}
              currentPage={currentPage2}
              pageNumbers={pageNumbers2}
              setCurrentPage={setCurrentPage2}
            />
          </div>
        </div>
      )}

      {clearForm && (
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center ">
            <ClearForm
              message="Arbitrator Assigned Successfully!"
              redirectPath="/instdashboard"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignArbitrator;
